/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_Payment_HintInputs */

const en_loading_payment_hint = /** @type {(inputs: Loading_Payment_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep this page open while we prepare the payment details.`)
};

const id_loading_payment_hint = /** @type {(inputs: Loading_Payment_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biarkan halaman ini terbuka selama rincian pembayaran disiapkan.`)
};

/**
* | output |
* | --- |
* | "Keep this page open while we prepare the payment details." |
*
* @param {Loading_Payment_HintInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const loading_payment_hint = /** @type {((inputs?: Loading_Payment_HintInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_Payment_HintInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_loading_payment_hint(inputs)
	return en_loading_payment_hint(inputs)
});